import React, { useEffect, useState, useRef } from 'react';
import { useFrontContext } from '../providers/frontContext';
import AgentAssist from './AgentAssist';
import MotionContact from './MotionContact';
import { findLatestInboundMessage } from './util';
import { init } from '@amplitude/analytics-browser';

function Plugin() {
  const context = useFrontContext();
  const [rawMesseages, setRawMessages] = useState();
  // handle error later
  // eslint-disable-next-line no-unused-vars
  const [_, setError] = useState();
  const [contacts, setContacts] = useState({});
  const latestInbound = useRef();
  const lastRawMessages = useRef();

  useEffect(() => {
    init(process.env.REACT_APP_AMPLITUDE_KEY, context.teammate.email);
  }, [context.teammate.email]);

  useEffect(() => {
    context.listMessages().then(async (response) => {
      const rawMessages = response.results;

      if (
        rawMessages != null &&
        (lastRawMessages.current == null ||
          lastRawMessages.current[0].id !== rawMessages[0].id)
      ) {
        setRawMessages(rawMessages);
        setContacts({});
        if (rawMessages != null && rawMessages.length > 0) {
          latestInbound.current = findLatestInboundMessage(rawMessages);
        } else {
          latestInbound.current = undefined;
        }
        lastRawMessages.current = rawMessages;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);

  // const subscription = useMemo(() => {
  //   return findContactWithMentionedSubscription(contacts);
  // }, [contacts]);

  return (
    <>
      <MotionContact
        latestInbound={latestInbound}
        setError={setError}
        contacts={contacts}
        setContacts={(currentContacts) => {
          setContacts(currentContacts);
        }}
      />
      <AgentAssist
        rawMessages={rawMesseages}
        latestInbound={latestInbound}
        contacts={contacts}
      />
      {/* {intent === 'cancel' && Object.entries(contacts).length > 0 && (
        <Cancel
          environmentData={
            subscription == null
              ? { email: Object.keys(contacts)[0] }
              : extractEnvironmentData(subscription[0], subscription[1])
          }
          latestInbound={latestInbound}
        />
      )} */}
    </>
  );
}

export default Plugin;
